var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open && _vm.edge
    ? _c(
        "div",
        {
          staticClass: "wkb-edge-action-menu",
          style: { left: `${_vm.clampedLeft}px`, top: `${_vm.clampedTop}px` },
          attrs: {
            role: "menu",
            "aria-label": `Actions for ${_vm.edge.label || _vm.edge.edgeId}`,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "wkb-edge-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: {
                click: function ($event) {
                  return _vm.emitAndClose("inspect")
                },
              },
            },
            [_vm._v(" Inspect edge ")]
          ),
          _c(
            "button",
            {
              staticClass: "wkb-edge-action-btn",
              attrs: { type: "button", role: "menuitem" },
              on: {
                click: function ($event) {
                  return _vm.emitAndClose("expand")
                },
              },
            },
            [_vm._v(" Expand graph from edge ")]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }